import React from "react";

// Chakra imports
import { Flex, Image, useColorModeValue } from "@chakra-ui/react";

// Custom components
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  //   Chakra color mode
    const logoSrc = useColorModeValue('/logo/logo_light.svg','/logo/logo_dark.svg');

  return (
    <Flex align='center' direction='column'>
      <Image src={logoSrc} w='175px' my='32px'/>
      <HSeparator mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
